import axios from 'axios'
import { ContactSlugEnum } from 'src/shared/enums/contact-fields-enum'
import { EntityIdType } from 'src/shared/schemas/entity-id.schema'
import { CustomFieldSlugType } from 'src/shared/schemas/field/common-field-entity-and-sub-entity.schema'

export type FormFieldsApiType = Array<{
  slug: ContactSlugEnum | CustomFieldSlugType
  value: string | undefined
}>

export interface FormOptInArgs {
  fields: FormFieldsApiType
  formId: EntityIdType
  timezone: string
}

export const formOptIn = ({ fields, formId, timezone }: FormOptInArgs) =>
  axios.post<{ redirect?: string }>('/api/monolith-opt-in/open/global/opt-in', {
    fields,
    formId,
    timezone,
  })
